import { render, staticRenderFns } from "./UserInfoUpper.vue?vue&type=template&id=83db9b26&"
import script from "./UserInfoUpper.vue?vue&type=script&lang=js&"
export * from "./UserInfoUpper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports